// extracted by mini-css-extract-plugin
export var children = "styles-module--children--746ae";
export var content = "styles-module--content--8f88d";
export var feature = "styles-module--feature--b4f5e";
export var features = "styles-module--features--95396";
export var heading = "styles-module--heading--61a7a";
export var icon = "styles-module--icon--57419";
export var stinger = "styles-module--stinger--b5c41";